import type { AddSolutionFormValues } from "./types";

export const writeableSolutionFormDefaults: AddSolutionFormValues = {
  "solution-name": "",
  "solution-vbc-website-display-name": "",
  "solution-developer": "",
  "solution-short-description": "",
  "country-select": null,
  "solution-development-stage": [],
  "solution-assessment-methodology": null,
  "solution-intervention-type": null,
  "solution-is-ready-for-sale": false,
  "solution-not-ready-for-sale-reason": null,
  "solution-start-date": null,
  "solution-end-date": null,
  "solution-is-carbon-offset": false,
  latitude: "",
  longitude: "",
  "location-pin-map-link": "",
  "solution-sdg": [],
  interventions: [],
  outcomes: [
    {
      unit: "",
      value: "",
      "unit-of-sale": false,
      "outcome-start-date": null,
      "outcome-end-date": null,
      outcomeCounter: 1,
      origin: "draft" as const,
    },
  ],
  "programme-info": {
    "carbon-crediting-programme": [],
    "carbon-accounting-methodology": "",
    "description-document": "",
    "asset-type": null,
  },
  "internal-details": {
    "website-url": "",
    "xero-account-number": "",
    "research-team-notes": "",
    "additional-resources-link": "",
  },
  "commercial-information": {
    "minimum-order": "",
  },
  narrative: {
    "project-information": "",
    "area-through-time": "",
    "good-for-people": "",
    "good-for-earth": "",
  },
  "satellite-imagery": [],
  "risk-monitoring": {
    "is-risk-alert-enabled": false,
    "buffer-value-km": 10,
    "geospatial-file": null,
  },
};
